export default __webpack_public_path__ + "static/media/zoom-out.6245b46b.svg";